/**
 * Creates a new command.
 * @param name - The friendly name of the command
 * @param owner - The owner of the command
 * @param action - The action to execute when the command is executed
 * @returns The new command
 */
export function CreateCommand(name, owner, action) {
    return {
        name,
        owner,
        action,
    };
}
//# sourceMappingURL=command.js.map